import { render, staticRenderFns } from "./phases.vue?vue&type=template&id=84ecf2c4"
import script from "./phases.vue?vue&type=script&lang=js"
export * from "./phases.vue?vue&type=script&lang=js"
import style0 from "./phases.vue?vue&type=style&index=0&id=84ecf2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports